import {
  faInfo,
  faXmarkCircle
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import { useEffect, useRef, useState } from 'react';
import { getSetType } from '../../../../myContent/utils/getSetType';
import { useLocation } from 'react-router';
import ActivityTypes from '../../../../../enums/activityTypes';

const PrintContainer = ({
  assignmentName,
  setName,
  displayTopValue,
  fontStyleClass,
  printOptions,
  isLoading,
  teacherName,
  vocabularyData,
  handleVocabularySelect,
  handleClearAll,
  setContentHeights,
  hideDuplicate,
  activityType
}) => {
  const [duplicateStacks, setDuplicateStacks] = useState([]);
  const questionsContainerRef = useRef(null);
  const duplicateDivRef = useRef(null);
  const location = useLocation();
  const activeTab = location.pathname.toLowerCase().split('/mycontent/')[1]?.split('/')[0];

  useEffect(() => {
    if(!duplicateStacks || duplicateStacks?.length === 0) return;

    if (duplicateDivRef.current) {
      const heights = vocabularyData.map(qs => {
        const items = duplicateDivRef.current.querySelector(`#dstack_itemId_${qs.id}`);
        if (!items) return { id: qs.questionId, height: 0 };
  
        return {
          id: qs.id,
          height: items.offsetHeight
        };
      });
  
      var header = questionsContainerRef.current.querySelector('#documentHeader');
      heights.push({
        id: 'header',
        height: header.offsetHeight + 50
      });
      setContentHeights(heights);
    }
  }, [duplicateStacks]);

  useEffect(() => {
    if (vocabularyData?.length === 0) return;
  
    let singleStack = vocabularyData?.map((item) => ({
      ...item
    }));
  
    setDuplicateStacks(singleStack);
  }, [printOptions, vocabularyData]);

  const RenderItem = (item, index, isDuplicate = false) => {
    return (
      <div key={index} className={`check-items d-flex gap-2 py-2 mb-2 ${!item?.isChecked ? 'doNotPrint' : 'printData check-items-border'}`}>
        {!isDuplicate && <input
          type="checkbox"
          className="form-check-input checkboxes"
          name={`vocabulary${item.id}`}
          checked={!!item?.isChecked}
          onChange={handleVocabularySelect}
        />}
        <div className={`mx-2 ${!item?.isChecked ? 'doNotPrint' : 'printData'}`}>
          <div
            className="topic"
            dangerouslySetInnerHTML={{
              __html: UpdateImgTags(item.name)
            }}></div>
          {printOptions?.hideDefinition ? (<></>) : (
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html: UpdateImgTags(item.description)
              }}></div>
          )}
        </div>
      </div>
    );
  };

  const UpdateImgTags = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const imgs = doc.querySelectorAll('img');
    const standardWidth = 500;
    const baseWidth = printOptions?.twoColumn ? standardWidth/2 : standardWidth;
    const compressionScale = 1 - printOptions?.imageCompressionPercent / 100;
    const finalWidth = Math.max(baseWidth * compressionScale, 50);

    imgs.forEach(img => {
      const src = img.getAttribute('src') || '';
      const isGeometryMathImage = ['geometry', 'math', 'algebra', 'precalc'].some(keyword => src.toLowerCase().includes(keyword));

      if (!isGeometryMathImage) {
        img.removeAttribute('width');
        img.removeAttribute('height');

        img.style.maxWidth = `${baseWidth}px`;
        img.style.width = `${finalWidth}px`;
        img.style.height = 'auto';
      }
    });
    return doc.body.innerHTML;
  };
  
    
  return (
    <div className="vocabulary-content-scroll">
      <div id="vocabulary-data">
        {isLoading ?
          <div className='print-content p-4'>
            <SkeletonGrid
              rowCount={2}
              colCount={2}
              className='mt-2' />
            <SkeletonGrid
              rowCount={4}
              colCount={1}
              className='p-3 h-150 mt-3'
            />
          </div>
          :
          <div className="print-content vocabulary-content-data">
            <div ref={questionsContainerRef} className={`${fontStyleClass} content-${printOptions?.fontSize}`}>
              <div id="documentHeader" className='name-slip border-0 mb-3'>
                <div className='d-flex justify-content-between'>
                  <div className="d-flex align-items-center row">
                    <div>
                      {printOptions?.showNameLine && (
                        <div>
                          <label className="form-label"><b>Name:</b></label>
                          <input className="input-name" disabled></input>
                        </div>
                      )}
                    </div>
                    <div>
                      {printOptions?.showTeacherName && (
                        <label className="form-label teacher-name">
                          <b>Teacher:</b>&nbsp;&nbsp;<span>{teacherName}</span>
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="d-flex align-items-center row">
                    {(assignmentName || setName) && (
                      <label className="form-label d-flex justify-content-end">
                        <b>{activityType == ActivityTypes.FlashCard ? 'Flashcard Name:' : (assignmentName ? 'Assignment Name:' : 'Set Name:')}</b>&nbsp;&nbsp;
                        {assignmentName || setName}
                      </label>
                    )}
                    <label className="form-label d-flex justify-content-end">
                      <b>{getSetType(activeTab) != '' ? getSetType(activeTab) + 's:' : 'Vocabulary:'}</b>&nbsp;&nbsp;
                      {vocabularyData?.length}
                    </label>
                  </div>
                </div>
                {displayTopValue?.length > 0 && (
                  <h3 className={`mb-3 text-center content-${printOptions?.fontSize}`}>{displayTopValue}</h3>
                )}
              </div>
              <div className="name-slip py-2 row" id="checkData">
                <div className="col-lg-6 d-flex align-items-center gap-3">
                  <div className="d-flex gap-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="selectAll"
                      checked={vocabularyData?.every((item) => item.isChecked)}
                      onChange={handleVocabularySelect}
                    />{' '}
                    <label className="form-label mb-0">Check All</label>
                  </div>
                  <div className="d-flex align-items-center">
                    <button className="clear-btn" name="clearAll" onClick={handleClearAll}>
                      <FontAwesomeIcon icon={faXmarkCircle} className="close-mark" />
                        Clear All
                    </button>
                  </div>
                </div>
                <div className="col-lg-6 d-flex flex-row-reverse">
                  <div className="d-flex gap-1 align-items-center info-box">
                    <FontAwesomeIcon icon={faInfo} className="info-icon" />
                    <span>
                      Check the items you want to print
                    </span>{' '}
                  </div>
                </div>
              </div>
              <div id="documentContainer">
                {(() => {
                  const elementsToRender = [];
                  let leftColumn = [];
                  let rightColumn = [];
                  let currentStackNo = null;

                  vocabularyData?.forEach((item, index) => {
                    const hasPosition = item.position === 'left' || item.position === 'right';
                      
                    if (printOptions?.twoColumn && hasPosition) {
                      if (!currentStackNo && item.stackNo) {
                        currentStackNo = item.stackNo;
                      }
                      
                      if (item.position === 'left') leftColumn.push(item);
                      else rightColumn.push(item);
                      
                      const next = vocabularyData[index + 1];
                      const nextStackNo = next?.stackNo;
                      if (item.isEndStack) {
                        const stackNoForRender = currentStackNo;
                        elementsToRender.push(
                          <div key={`stack_${stackNoForRender ?? index}`} className={`d-flex row mb-2 ${stackNoForRender > 1 ? 'page-break-before' : ''}`}>
                            <div className='d-flex align-items-stretch justify-content-between my-2'>
                              <div style={{ width: '49%' }}>
                                {leftColumn.map((leftItem, leftIndex) => 
                                  RenderItem(leftItem, leftIndex)
                                )}
                              </div>
                              <div className='vertical-line'></div>
                              <div style={{ width: '49%' }}>
                                {rightColumn.map((rightItem, rightIndex) => 
                                  RenderItem(rightItem, rightIndex)
                                )}
                              </div>
                            </div>
                          </div>
                        );
                        leftColumn = [];
                        rightColumn = [];
                        currentStackNo = nextStackNo ?? null;
                      }
                    } else {
                      elementsToRender.push(
                        <div key={item.id} id={`question_${item.id}`} className="my-2">
                          {RenderItem(item, index)}
                        </div>
                      );
                    }
                  });
                      
                  return elementsToRender;
                })()}
              </div>
              {duplicateStacks && duplicateStacks.length > 0 && !hideDuplicate &&
              <div id='duplicate-item-div' ref={duplicateDivRef}>
                <div id="dstack" className="d-flex row mb-5">
                  <p className="d-flex justify-content-center fw-bold line">Duplicate Stack</p>
                  <div className="d-flex gap-3">
                    <div style={{ flex: 1 }}>
                      {duplicateStacks.map((item, index) => (
                        <div id={`dstack_itemId_${item.id}`} key={`dstack_itemId_${item.id}`} className={`dstack_itemId_${item.id}`}>
                          {RenderItem(item, index, true)}
                        </div>
                      ))}
                    </div>
                    <div style={{ flex: 1 }} />
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  );
};

PrintContainer.propTypes = {
  assignmentName: PropTypes.string,
  setName: PropTypes.string,
  displayTopValue: PropTypes.string,
  fontStyleClass: PropTypes.string,
  printOptions: PropTypes.object,
  isLoading: PropTypes.bool,
  teacherName: PropTypes.string,
  vocabularyData: PropTypes.array,
  handleVocabularySelect: PropTypes.func,
  handleClearAll: PropTypes.func,
  setContentHeights: PropTypes.func,
  hideDuplicate: PropTypes.bool,
  activityType: PropTypes.number
};

export default PrintContainer;